module.exports = __webpack_public_path__ + "static/feature-3-8ade03ae2dddec9a70b81eac83153261.svg";